// زخرف store contact + brand config
export const BRAND = "زخرف";
export const SLOGAN = "فخامة الإنطباع الأول";
export const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_invite-platform-4/artifacts/zasglcg6_%D8%B4%D8%B9%D8%A7%D8%B1%20-%20%D8%B2%D8%AE%D8%B1%D9%81.png";
export const LOGO_ICON = "https://customer-assets-7cd3h4nn.emergentagent.net/job_invite-platform-4/artifacts/lapofxrw_%D8%B4%D8%B9%D8%A7%D8%B1%20-%20%D8%B2%D8%AE%D8%B1%D9%81%20%28%D8%B2%29.png";
export const PHONE_DISPLAY = "0509239713";
export const WHATSAPP_NUMBER = "966509239713";
export const INSTAGRAM_URL = "https://www.instagram.com/zukhruf_sstore";
export const INSTAGRAM_HANDLE = "zukhruf_sstore";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    text || "مرحبًا زخرف، أرغب بالاستفسار عن تصميم دعوة إلكترونية."
  )}`;

export const telLink = `tel:+${WHATSAPP_NUMBER}`;
